var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 7.59082V18.0908H12.25",
    stroke: "#721BE6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.25 35.5908V25.0908H29.75",
    stroke: "#721BE6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8575 16.3408C34.97 13.8327 33.4615 11.5903 31.4729 9.82281C29.4843 8.05534 27.0804 6.82042 24.4855 6.23328C21.8906 5.64615 19.1892 5.72593 16.6334 6.46518C14.0777 7.20444 11.7508 8.57908 9.87 10.4608L1.75 18.0908M40.25 25.0908L32.13 32.7208C30.2492 34.6026 27.9223 35.9772 25.3666 36.7165C22.8108 37.4557 20.1094 37.5355 17.5145 36.9484C14.9196 36.3612 12.5157 35.1263 10.5271 33.3588C8.53848 31.5914 7.03004 29.349 6.1425 26.8408",
    stroke: "#721BE6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.cf66a612e85e2c10a9c24f5c96cd303c.svg";
export { ForwardRef as ReactComponent };